export default "/new-order-alarm-sound.158683d1-51002a.mp3";